export function getDocPage(subpage, lang, modelsData, renderDocCodeTabs) {
  const isId = lang === 'id';
  const id = subpage || 'introduction';
  const activeModels = Array.isArray(modelsData) ? modelsData.filter(m => m.active !== false) : [];
  const exampleModelId = (activeModels.length > 0 && activeModels[0].id)
    || (Array.isArray(modelsData) && modelsData[0]?.id)
    || 'MODEL_ID';

  const docs = {
    'introduction': {
      category: isId ? 'Mulai di sini' : 'Start here',
      title: isId ? 'API OpenCSN' : 'The OpenCSN API',
      subtitle: isId
        ? 'Satu kunci dan satu URL dasar di depan berbagai pemasok model AI. Pertahankan SDK yang sudah dipakai aplikasi Anda, ubah URL dasar, dan pilih model berdasarkan ID-nya.'
        : 'One key and one base URL in front of many model providers. Keep the SDK your code already uses, change the base URL, and pick a model by its ID.',
      toc: isId
        ? ['Cara permintaan diarahkan', 'Pilih endpoint', 'Langkah berikutnya']
        : ['How a request is routed', 'Pick an endpoint', 'Where to go next'],
      prev: null,
      next: { id: 'quickstart', title: isId ? 'Memulai Cepat' : 'Quickstart' },
      content: () => `
        <div class="space-y-6 text-xs sm:text-sm text-sec">
          <div class="surface-card rounded-2xl p-5 space-y-4">
            <div class="flex items-center justify-between font-mono text-xs text-main">
              <span>https://api.opencsn.com/v1</span>
              <button data-copy="https://api.opencsn.com/v1" onclick="copyFromAttr(this)" class="px-2.5 py-1 rounded surface-card text-sec hover:text-main">${isId ? 'Salin' : 'Copy'}</button>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-3 border-t border-subtle text-xs">
              <div><div class="text-mut">${isId ? 'Header kunci' : 'Key header'}</div><div class="font-mono text-main mt-0.5">Authorization: Bearer atau x-api-key</div></div>
              <div><div class="text-mut">${isId ? 'Format body' : 'Body format'}</div><div class="text-main mt-0.5">JSON, sesuai jalur yang Anda panggil</div></div>
              <div><div class="text-mut">${isId ? 'Penagihan' : 'Billing'}</div><div class="text-main mt-0.5">${isId ? 'Per token, dari saldo prabayar' : 'Per token, from prepaid credit'}</div></div>
            </div>
          </div>
          <h3 class="text-base font-semibold text-main pt-2">${isId ? 'Cara permintaan diarahkan' : 'How a request is routed'}</h3>
          <p>${isId
            ? 'Dua komponen penting dalam setiap panggilan ke gateway bersifat independen. <b class="text-main">Path</b> menentukan format data yang Anda kirim dan terima. Kolom <b class="text-main">model</b> menentukan model AI yang menjawab. Model Claude dapat dipanggil lewat format OpenAI Chat Completions, dan model GPT dapat dipanggil lewat format Anthropic Messages; gateway melakukan konversi otomatis secara transparan.'
            : 'Two parts of a request matter to the gateway, and they are independent. The <b class="text-main">path</b> decides which wire format you send and get back. The <b class="text-main">model</b> field decides which model answers. A Claude model can be called through the OpenAI Chat Completions path, and a GPT model through the Anthropic Messages path; the gateway converts between formats on the way in and out.'}</p>
          <h3 class="text-base font-semibold text-main pt-2">${isId ? 'Pilih endpoint yang sesuai' : 'Pick an endpoint'}</h3>
          <table class="w-full text-left text-xs border-collapse">
            <thead><tr class="border-b border-subtle text-mut"><th class="py-2">${isId ? 'Jika aplikasi Anda memakai' : 'If your code uses'}</th><th class="py-2">${isId ? 'Panggil jalur' : 'Call'}</th><th class="py-2">${isId ? 'Dokumentasi' : 'Reference'}</th></tr></thead>
            <tbody class="divide-y divide-white/5">
              <tr><td class="py-2.5">OpenAI SDK, chat completions</td><td class="py-2.5 font-mono text-main">POST /v1/chat/completions</td><td class="py-2.5"><button onclick="navigate('/docs','chat-completions')" class="text-[#c87a51] underline">Chat Completions</button></td></tr>
              <tr><td class="py-2.5">OpenAI SDK, responses</td><td class="py-2.5 font-mono text-main">POST /v1/responses</td><td class="py-2.5"><button onclick="navigate('/docs','responses')" class="text-[#c87a51] underline">Responses</button></td></tr>
              <tr><td class="py-2.5">Anthropic SDK, messages</td><td class="py-2.5 font-mono text-main">POST /v1/messages</td><td class="py-2.5"><button onclick="navigate('/docs','messages')" class="text-[#c87a51] underline">Messages</button></td></tr>
              <tr><td class="py-2.5">Daftar model aktif</td><td class="py-2.5 font-mono text-main">GET /v1/models</td><td class="py-2.5"><button onclick="navigate('/docs','models-api')" class="text-[#c87a51] underline">Models</button></td></tr>
              <tr><td class="py-2.5">Pemeriksaan saldo akun</td><td class="py-2.5 font-mono text-main">GET /v1/me</td><td class="py-2.5"><button onclick="navigate('/docs','me-api')" class="text-[#c87a51] underline">Me</button></td></tr>
            </tbody>
          </table>
        </div>
      `
    },
    'quickstart': {
      category: isId ? 'Mulai di sini' : 'Start here',
      title: isId ? 'Memulai Cepat' : 'Quickstart',
      subtitle: isId
        ? 'Dari pembuatan akun hingga menerima respons model di terminal Anda dalam beberapa menit.'
        : "From no account to a model's answer in your terminal. Each step below takes a minute.",
      toc: isId ? ['Langkah-langkah', 'Contoh respons', 'Langkah berikutnya'] : ['Steps', 'What came back', 'Next'],
      prev: { id: 'introduction', title: isId ? 'Pengenalan' : 'Introduction' },
      next: { id: 'authentication', title: isId ? 'Autentikasi' : 'Authentication' },
      content: () => `
        <div class="space-y-6 text-xs sm:text-sm text-sec">
          <div class="space-y-4">
            <div><b class="text-main">1. ${isId ? 'Buat akun dan isi saldo' : 'Create an account and add credit'}</b> — ${isId ? 'Buka halaman Tagihan pada konsol. Panggilan ke API membutuhkan saldo aktif.' : 'Open the Billing page of the console. A request requires active credit.'}</div>
            <div><b class="text-main">2. ${isId ? 'Buat Kunci API' : 'Create an API key'}</b> — ${isId ? 'Buka menu API Keys di konsol dan klik buat kunci baru. Format kunci berawalan' : 'Open API keys in the console and create a key. Keys start with'} <code class="font-mono text-main">sk-opencsn-</code>.</div>
            <div><b class="text-main">3. ${isId ? 'Ekspor kunci ke environment' : 'Export the key'}</b></div>
            <pre class="surface-card rounded-xl p-4 font-mono text-xs text-main">export OPENCSN_API_KEY="sk-opencsn-..."</pre>
            <div><b class="text-main">4. ${isId ? 'Kirim permintaan pertama Anda' : 'Send a request'}</b></div>
            ${renderDocCodeTabs({
              curl: `curl https://api.opencsn.com/v1/chat/completions \\\n  -H "Authorization: Bearer $OpenCSN_API_KEY" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model":"${exampleModelId}","messages":[{"role":"user","content":"Halo!"}]}'`,
              python: `from openai import OpenAI\nimport os\n\nclient = OpenAI(base_url="https://api.opencsn.com/v1", api_key=os.environ["OpenCSN_API_KEY"])\ncompletion = client.chat.completions.create(\n    model="${exampleModelId}",\n    messages=[{"role": "user", "content": "Halo!"}],\n)\nprint(completion.choices[0].message.content)`,
              nodejs: `import OpenAI from "openai";\n\nconst client = new OpenAI({ baseURL: "https://api.opencsn.com/v1", apiKey: process.env.OpenCSN_API_KEY });\nconst completion = await client.chat.completions.create({\n  model: "${exampleModelId}",\n  messages: [{ role: "user", content: "Halo!" }],\n});\nconsole.log(completion.choices[0].message.content);`
            })}
          </div>
        </div>
      `
    },
    'authentication': {
      category: isId ? 'Mulai di sini' : 'Start here',
      title: isId ? 'Autentikasi' : 'Authentication',
      subtitle: isId
        ? 'Setiap panggilan API memerlukan kunci API yang valid melalui salah satu dari dua header standar.'
        : 'Every request carries one API key. The gateway reads it from either of two headers, on every endpoint.',
      toc: isId ? ['Header autentikasi', 'Format kunci', 'Kontrol kunci API'] : ['Which header carries the key', 'Key format', 'Key controls'],
      prev: { id: 'quickstart', title: isId ? 'Memulai Cepat' : 'Quickstart' },
      next: { id: 'chat-completions', title: '/v1/chat/completions' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <h3 class="text-base font-semibold text-main">${isId ? 'Header autentikasi yang didukung' : 'Which header carries the key'}</h3>
          <p>${isId
            ? 'Kirim kunci API melalui header <code class="font-mono text-main">Authorization</code> dengan awalan <code class="font-mono text-main">Bearer</code>, atau melalui header <code class="font-mono text-main">x-api-key</code>. Keduanya berlaku di seluruh endpoint.'
            : 'Send the key in <code class="font-mono text-main">Authorization</code> with the <code class="font-mono text-main">Bearer</code> prefix, or in <code class="font-mono text-main">x-api-key</code>. Both work on all paths.'}</p>
          <pre class="surface-card rounded-xl p-4 font-mono text-xs text-main">Authorization: Bearer sk-opencsn-...\nx-api-key: sk-opencsn-...</pre>
          <h3 class="text-base font-semibold text-main pt-2">${isId ? 'Kontrol keamanan kunci' : 'Key controls'}</h3>
          <p>${isId
            ? 'Setiap kunci dapat dibatasi saat dibuat: <b class="text-main">Batas pengeluaran</b> (jumlah USD), <b class="text-main">Periode reset</b> (harian/bulanan), <b class="text-main">Model yang diizinkan</b>, dan <b class="text-main">Kedaluwarsa</b>.'
            : 'Each key can be narrowed when you create it in API keys: <b class="text-main">Spend cap</b> (USD amount), <b class="text-main">Reset period</b> (daily/monthly), <b class="text-main">Allowed models</b>, and <b class="text-main">Expiry</b>.'}</p>
        </div>
      `
    },
    'chat-completions': {
      category: isId ? 'Referensi API' : 'API reference',
      title: 'Chat Completions',
      subtitle: isId
        ? 'Format OpenAI Chat Completions. Format dengan dukungan terluas pada berbagai library, tool koding, dan framework.'
        : 'The OpenAI Chat Completions format. The widest-supported format among existing tools, and the default choice if you are unsure.',
      toc: isId ? ['Format permintaan', 'Parameter utama', 'Format respons'] : ['Request', 'Body fields', 'Response'],
      prev: { id: 'authentication', title: isId ? 'Autentikasi' : 'Authentication' },
      next: { id: 'responses', title: '/v1/responses' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <div class="surface-card rounded-xl p-4 font-mono text-xs text-main"><span class="text-emerald-400 font-bold mr-2">POST</span> https://api.opencsn.com/v1/chat/completions</div>
          ${renderDocCodeTabs({
            curl: `curl https://api.opencsn.com/v1/chat/completions \\\n  -H "Authorization: Bearer $OpenCSN_API_KEY" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model":"${exampleModelId}","messages":[{"role":"user","content":"Halo!"}]}'`,
            python: `completion = client.chat.completions.create(model="${exampleModelId}", messages=[{"role":"user","content":"Halo!"}])`,
            nodejs: `const completion = await client.chat.completions.create({ model: "${exampleModelId}", messages: [{ role: "user", content: "Halo!" }] });`
          })}
        </div>
      `
    },
    'responses': {
      category: isId ? 'Referensi API' : 'API reference',
      title: 'Responses',
      subtitle: isId
        ? 'Format OpenAI Responses: satu kolom input berupa string atau daftar item, dengan respons terstruktur.'
        : 'The OpenAI Responses format: one input field that takes a string or a list of items, and typed output items back.',
      toc: ['Request', 'Body fields', 'Response'],
      prev: { id: 'chat-completions', title: '/v1/chat/completions' },
      next: { id: 'messages', title: '/v1/messages' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <div class="surface-card rounded-xl p-4 font-mono text-xs text-main"><span class="text-emerald-400 font-bold mr-2">POST</span> https://api.opencsn.com/v1/responses</div>
          ${renderDocCodeTabs({
            curl: `curl https://api.opencsn.com/v1/responses \\\n  -H "Authorization: Bearer $OpenCSN_API_KEY" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model":"${exampleModelId}","input":"Sebutkan 3 tips coding."}'`,
            python: `response = client.responses.create(model="${exampleModelId}", input="Sebutkan 3 tips coding.")`,
            nodejs: `const response = await client.responses.create({ model: "${exampleModelId}", input: "Sebutkan 3 tips coding." });`
          })}
        </div>
      `
    },
    'messages': {
      category: isId ? 'Referensi API' : 'API reference',
      title: 'Messages',
      subtitle: isId
        ? 'Format Anthropic Messages. Gunakan format ini jika aplikasi Anda dibangun di atas Anthropic SDK.'
        : 'The Anthropic Messages format. Use it when your code or tool is built on the Anthropic SDK, including for models that are not Claude.',
      toc: ['Request', 'Body fields', 'Response'],
      prev: { id: 'responses', title: '/v1/responses' },
      next: { id: 'systemone', title: '/v1/systemone' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <div class="surface-card rounded-xl p-4 font-mono text-xs text-main"><span class="text-emerald-400 font-bold mr-2">POST</span> https://api.opencsn.com/v1/messages</div>
          ${renderDocCodeTabs({
            curl: `curl https://api.opencsn.com/v1/messages \\\n  -H "x-api-key: $OpenCSN_API_KEY" \\\n  -H "anthropic-version: 2023-06-01" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model":"${exampleModelId}","max_tokens":1024,"messages":[{"role":"user","content":"Halo!"}]}'`,
            python: `message = client.messages.create(model="${exampleModelId}", max_tokens=1024, messages=[{"role":"user","content":"Halo!"}])`,
            nodejs: `const message = await client.messages.create({ model: "${exampleModelId}", max_tokens: 1024, messages: [{ role: "user", content: "Halo!" }] });`
          })}
        </div>
      `
    },
    'systemone': {
      category: isId ? 'Referensi API' : 'API reference',
      title: 'SystemOne',
      subtitle: isId
        ? 'Endpoint evaluasi state dan pertanyaan terstruktur untuk agen otonom.'
        : 'Structured state-and-questions evaluation endpoint backed by the OpenCode System One vendor.',
      toc: ['Request', 'Body fields', 'Response'],
      prev: { id: 'messages', title: '/v1/messages' },
      next: { id: 'models-api', title: '/v1/models' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <div class="surface-card rounded-xl p-4 font-mono text-xs text-main"><span class="text-emerald-400 font-bold mr-2">POST</span> https://api.opencsn.com/v1/systemone</div>
          <pre class="surface-card rounded-xl p-4 font-mono text-xs text-main overflow-x-auto">{\n  "model": "${exampleModelId}",\n  "state": "Need assistance connecting database.",\n  "questions": {\n    "urgency": { "type": "noul", "instructions": "Does this message express urgency?" }\n  }\n}</pre>
        </div>
      `
    },
    'models-api': {
      category: isId ? 'Referensi API' : 'API reference',
      title: isId ? 'Daftar Model' : 'List models',
      subtitle: isId
        ? 'Daftar seluruh model aktif yang diteruskan oleh gateway dalam format standar OpenAI.'
        : 'Every model the gateway routes, in the OpenAI list format that SDKs read, plus the fields a model picker or cost estimator needs.',
      toc: ['Request', 'Response', 'Pricing'],
      prev: { id: 'systemone', title: '/v1/systemone' },
      next: { id: 'me-api', title: '/v1/me' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <div class="surface-card rounded-xl p-4 font-mono text-xs text-main"><span class="text-sky-400 font-bold mr-2">GET</span> https://api.opencsn.com/v1/models</div>
          <pre class="surface-card rounded-xl p-4 font-mono text-xs text-main overflow-x-auto">{\n  "object": "list",\n  "data": [\n    {\n      "id": "${exampleModelId}",\n      "object": "model",\n      "owned_by": "openai",\n      "context_length": 1048576\n    }\n  ]\n}</pre>
        </div>
      `
    },
    'me-api': {
      category: isId ? 'Referensi API' : 'API reference',
      title: isId ? 'Status Akun & Saldo' : 'Account & key status',
      subtitle: isId
        ? 'Periksa sisa saldo akun, status kunci API, dan limit yang berlaku.'
        : 'Check what your key can still spend, your remaining balance, and active plan credits.',
      toc: ['Request', 'Response'],
      prev: { id: 'models-api', title: '/v1/models' },
      next: { id: 'errors', title: isId ? 'Penanganan Error' : 'Errors' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <div class="surface-card rounded-xl p-4 font-mono text-xs text-main"><span class="text-sky-400 font-bold mr-2">GET</span> https://api.opencsn.com/v1/me</div>
          <pre class="surface-card rounded-xl p-4 font-mono text-xs text-main overflow-x-auto">{\n  "object": "me",\n  "status": "active",\n  "balance_usd": "10.0000",\n  "available_usd": "10.0000"\n}</pre>
        </div>
      `
    },
    'errors': {
      category: isId ? 'Referensi API' : 'API reference',
      title: isId ? 'Penanganan Error' : 'Errors',
      subtitle: isId
        ? 'Gunakan kolom kode (code) untuk percabangan logika error pada aplikasi Anda.'
        : 'Branch on the code field, not the message. Codes are stable; messages are written for people and can change.',
      toc: ['Error envelopes', 'Codes', 'Headers to read', 'Retrying'],
      prev: { id: 'me-api', title: '/v1/me' },
      next: { id: 'sdks', title: isId ? 'Panduan SDK Resmi' : 'Official SDKs' },
      content: () => `
        <div class="space-y-4 text-xs text-sec">
          <table class="w-full text-left border-collapse">
            <thead><tr class="border-b border-subtle text-mut"><th class="py-2">Status</th><th class="py-2">Code</th><th class="py-2">${isId ? 'Arti' : 'Meaning'}</th></tr></thead>
            <tbody class="divide-y divide-white/5 font-mono">
              <tr><td class="py-2">400</td><td class="py-2 text-main">invalid_request</td><td class="py-2 font-sans">${isId ? 'Format body salah atau parameter tidak didukung.' : 'Malformed body or unsupported parameter.'}</td></tr>
              <tr><td class="py-2">401</td><td class="py-2 text-main">unauthorized</td><td class="py-2 font-sans">${isId ? 'Kunci API hilang, salah, atau kedaluwarsa.' : 'The key is missing, wrong, disabled or expired.'}</td></tr>
              <tr><td class="py-2">402</td><td class="py-2 text-main">insufficient_credit</td><td class="py-2 font-sans">${isId ? 'Saldo tidak mencukupi untuk panggilan ini.' : 'The balance cannot cover this request.'}</td></tr>
              <tr><td class="py-2">429</td><td class="py-2 text-main">rate_limit_exceeded</td><td class="py-2 font-sans">${isId ? 'Batas laju permintaan terlampaui.' : 'Too many requests per minute.'}</td></tr>
              <tr><td class="py-2">502</td><td class="py-2 text-main">upstream_error</td><td class="py-2 font-sans">${isId ? 'Pemasok upstream mengembalikan error; coba lagi nanti.' : 'The provider returned an error; retry with backoff.'}</td></tr>
            </tbody>
          </table>
        </div>
      `
    },
    'sdks': {
      category: isId ? 'Panduan' : 'Guides',
      title: isId ? 'Panduan SDK Resmi' : 'Official SDKs',
      subtitle: isId
        ? 'Tidak ada SDK khusus OpenCSN yang perlu diinstal. Cukup gunakan SDK resmi OpenAI atau Anthropic dan arahkan baseURL ke OpenCSN.'
        : 'There is no OpenCSN SDK to install. The official OpenAI and Anthropic SDKs work once they point at the gateway.',
      toc: ['OpenAI SDK', 'Anthropic SDK', 'Other tools'],
      prev: { id: 'errors', title: isId ? 'Penanganan Error' : 'Errors' },
      next: { id: 'streaming', title: isId ? 'Streaming Respons' : 'Streaming' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <pre class="surface-card rounded-xl p-4 font-mono text-xs text-main">export OPENAI_BASE_URL="https://api.opencsn.com/v1"\nexport OPENAI_API_KEY="$OpenCSN_API_KEY"\nexport ANTHROPIC_BASE_URL="https://api.opencsn.com"\nexport ANTHROPIC_API_KEY="$OpenCSN_API_KEY"</pre>
        </div>
      `
    },
    'streaming': {
      category: isId ? 'Panduan' : 'Guides',
      title: isId ? 'Streaming Respons' : 'Streaming',
      subtitle: isId
        ? 'Tambahkan parameter "stream": true pada body dan respons akan dikirim secara real-time via Server-Sent Events.'
        : 'Add "stream": true to the body and the reply arrives as Server-Sent Events while it is generated.',
      toc: ['Events by endpoint', 'Chat Completions', 'Responses', 'Messages'],
      prev: { id: 'sdks', title: isId ? 'Panduan SDK Resmi' : 'Official SDKs' },
      next: { id: 'models-guide', title: isId ? 'Panduan Model' : 'Models' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          ${renderDocCodeTabs({
            curl: `curl -N https://api.opencsn.com/v1/chat/completions \\\n  -H "Authorization: Bearer $OpenCSN_API_KEY" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model":"${exampleModelId}","stream":true,"messages":[{"role":"user","content":"Hitung dari satu sampai lima."}]}'`,
            python: `stream = client.chat.completions.create(model="${exampleModelId}", messages=[{"role":"user","content":"Hitung dari satu sampai lima."}], stream=True)\nfor chunk in stream:\n    print(chunk.choices[0].delta.content or "", end="", flush=True)`,
            nodejs: `const stream = await client.chat.completions.create({ model: "${exampleModelId}", messages: [{ role: "user", content: "Hitung dari satu sampai lima." }], stream: true });\nfor await (const chunk of stream) {\n  process.stdout.write(chunk.choices[0]?.delta?.content ?? "");\n}`
          })}
        </div>
      `
    },
    'models-guide': {
      category: isId ? 'Panduan' : 'Guides',
      title: isId ? 'Panduan Model' : 'Models',
      subtitle: isId
        ? 'Gunakan ID model yang tertera di bawah pada kolom model di endpoint chat mana pun.'
        : 'Send any chat model ID below as the model field, on any chat endpoint. These tables are read from the gateway every minute.',
      toc: ['Model IDs', 'Choosing the endpoint for a model', 'Web search with :online'],
      prev: { id: 'streaming', title: isId ? 'Streaming Respons' : 'Streaming' },
      next: { id: 'plans', title: isId ? 'Paket Langganan' : 'Plans' },
      content: () => `
        <div class="overflow-x-auto text-xs">
          <table class="w-full text-left border-collapse">
            <thead><tr class="border-b border-subtle text-mut"><th class="py-2">Model ID</th><th class="py-2">Name</th><th class="py-2">Context</th><th class="py-2">Input / 1M</th><th class="py-2">Output / 1M</th><th class="py-2">${isId ? 'Diskon' : 'Discount'}</th></tr></thead>
            <tbody class="divide-y divide-white/5 font-mono">
              ${(modelsData || []).map(m => `
                <tr>
                  <td class="py-2 text-main">${m.id} ${m.free ? `<span class="text-xs px-1.5 py-0.5 rounded bg-emerald-500/15 text-emerald-400 font-sans">${isId ? 'Gratis' : 'Free'}</span>` : ''}</td>
                  <td class="py-2 font-sans text-sec">${m.name}</td>
                  <td class="py-2 text-sec">${m.context}</td>
                  <td class="py-2 text-main">$${Number(m.input).toFixed(2)}</td>
                  <td class="py-2 text-main">$${Number(m.output).toFixed(2)}</td>
                  <td class="py-2 text-[#c87a51]">${m.discount}% off</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `
    },
    'plans': {
      category: isId ? 'Panduan' : 'Guides',
      title: isId ? 'Paket Langganan' : 'Plans',
      subtitle: isId
        ? 'Paket memberikan saldo pemakaian dengan batas laju request dan konkurensi lebih tinggi.'
        : 'A plan is a set amount of usage for a fixed period, with higher rate limits while it runs.',
      toc: ['Plans at a glance', 'How the token estimate is worked out'],
      prev: { id: 'models-guide', title: isId ? 'Panduan Model' : 'Models' },
      next: { id: 'web-search', title: isId ? 'Pencarian Web' : 'Web search' },
      content: () => `
        <div class="space-y-6 text-xs text-sec">
          <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="border-b border-subtle text-mut">
                  <th class="py-2 pr-3">${isId ? 'Paket' : 'Plan'}</th>
                  <th class="py-2 px-3">${isId ? 'Harga' : 'Price'}</th>
                  <th class="py-2 px-3">${isId ? 'Saldo Pemakaian' : 'Usage included'}</th>
                  <th class="py-2 px-3">${isId ? 'Permintaan / Menit' : 'Requests per minute'}</th>
                  <th class="py-2 px-3">${isId ? 'Konkurensi' : 'At once'}</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-white/5">
                <tr><td class="py-2.5 pr-3 font-semibold text-main">Go</td><td class="py-2.5 px-3 font-mono">$2 / 14 days</td><td class="py-2.5 px-3 font-mono">$10</td><td class="py-2.5 px-3 font-mono">50</td><td class="py-2.5 px-3 font-mono">3</td></tr>
                <tr><td class="py-2.5 pr-3 font-semibold text-main">Pro</td><td class="py-2.5 px-3 font-mono">$12 / 21 days</td><td class="py-2.5 px-3 font-mono">$48</td><td class="py-2.5 px-3 font-mono">150</td><td class="py-2.5 px-3 font-mono">10</td></tr>
                <tr><td class="py-2.5 pr-3 font-semibold text-main">Max</td><td class="py-2.5 px-3 font-mono">$20 / month</td><td class="py-2.5 px-3 font-mono">$75</td><td class="py-2.5 px-3 font-mono">250</td><td class="py-2.5 px-3 font-mono">20</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      `
    },
    'web-search': {
      category: isId ? 'Panduan' : 'Guides',
      title: isId ? 'Pencarian Web' : 'Web search',
      subtitle: isId
        ? 'Tambahkan suffix :online pada model ID untuk memungkinkan pencarian web saat menghasilkan jawaban.'
        : 'Add :online to a model ID and the model can search the web while it answers, whatever model it is.',
      toc: ['The :online suffix'],
      prev: { id: 'plans', title: isId ? 'Paket Langganan' : 'Plans' },
      next: { id: 'mcp', title: isId ? 'Server MCP' : 'MCP server' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <h3 class="text-base font-semibold text-main">${isId ? 'Suffix :online' : 'The :online suffix'}</h3>
          <p>${isId
            ? 'Tambahkan <code class="font-mono text-main">:online</code> pada ID model. Tidak ada perubahan lain pada permintaan.'
            : 'Append <code class="font-mono text-main">:online</code> to the model ID. Nothing else in the request changes.'}</p>
          ${renderDocCodeTabs({
            curl: `curl https://api.opencsn.com/v1/chat/completions \\\n  -H "Authorization: Bearer $OpenCSN_API_KEY" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model":"${exampleModelId}:online","messages":[{"role":"user","content":"Berapa harga emas Antam hari ini?"}]}'`,
            python: `completion = client.chat.completions.create(\n    model="${exampleModelId}:online",\n    messages=[{"role": "user", "content": "Berapa harga emas Antam hari ini?"}],\n)`,
            nodejs: `const completion = await client.chat.completions.create({\n  model: "${exampleModelId}:online",\n  messages: [{ role: "user", content: "Berapa harga emas Antam hari ini?" }],\n});`
          })}
        </div>
      `
    },
    'mcp': {
      category: isId ? 'Panduan' : 'Guides',
      title: isId ? 'Server MCP' : 'MCP server',
      subtitle: isId
        ? 'OpenCSN mendukung Model Context Protocol (MCP) untuk integrasi langsung ke Claude Code, Cursor, dan tool agen lainnya.'
        : 'OpenCSN is also an MCP server. Add it to Claude Code, Cursor or any client that speaks the Model Context Protocol.',
      toc: ['Claude Code', 'Cursor'],
      prev: { id: 'web-search', title: isId ? 'Pencarian Web' : 'Web search' },
      next: { id: 'billing', title: isId ? 'Tagihan dan Batasan' : 'Billing and limits' },
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <h3 class="text-base font-semibold text-main">Claude Code</h3>
          <div class="surface-card rounded-xl p-4 font-mono text-xs text-main flex items-center justify-between">
            <span>claude mcp add --transport http OpenCSN https://api.opencsn.com/v1/mcp --header "Authorization: Bearer $OpenCSN_API_KEY"</span>
            <button data-copy="claude mcp add --transport http OpenCSN https://api.opencsn.com/v1/mcp" onclick="copyFromAttr(this)" class="px-2.5 py-1 rounded surface-card text-sec ml-3 shrink-0">${isId ? 'Salin' : 'Copy'}</button>
          </div>
          <h3 class="text-base font-semibold text-main">Cursor (~/.cursor/mcp.json)</h3>
          <pre class="surface-card rounded-xl p-4 font-mono text-xs text-main overflow-x-auto">{\n  "mcpServers": {\n    "OpenCSN": {\n      "url": "https://api.opencsn.com/v1/mcp",\n      "headers": { "Authorization": "Bearer sk-opencsn-..." }\n    }\n  }\n}</pre>
        </div>
      `
    },
    'billing': {
      category: isId ? 'Panduan' : 'Guides',
      title: isId ? 'Tagihan dan Batasan' : 'Billing and limits',
      subtitle: isId
        ? 'Pembayaran dihitung berdasarkan token nyata yang digunakan pada harga resmi setiap model.'
        : "You pay for the tokens a request actually used, at the model's listed price.",
      toc: isId ? ['Tahapan penagihan'] : ['What happens to one request'],
      prev: { id: 'mcp', title: isId ? 'Server MCP' : 'MCP server' },
      next: null,
      content: () => `
        <div class="space-y-5 text-xs sm:text-sm text-sec">
          <h3 class="text-base font-semibold text-main">${isId ? 'Siklus hidup setiap permintaan' : 'What happens to one request'}</h3>
          <ol class="list-decimal pl-5 space-y-2">
            <li><b class="text-main">${isId ? 'Reservasi' : 'Reserve'}</b> — ${isId ? 'Sebelum memanggil model, gateway memastikan saldo akun mencukupi batas maksimum biaya permintaan.' : 'Before calling the model, the gateway checks balance.'}</li>
            <li><b class="text-main">${isId ? 'Panggilan model' : 'Call the model'}</b> — ${isId ? 'Permintaan diteruskan ke pemasok model.' : 'The request goes to the provider.'}</li>
            <li><b class="text-main">${isId ? 'Penyelesaian' : 'Settle'}</b> — ${isId ? 'Setelah respons selesai, saldo dipotong secara tepat sesuai token aktual dalam objek usage.' : 'When the answer is complete, the charge is computed from actual tokens in usage.'}</li>
          </ol>
        </div>
      `
    }
  };

  return docs[id] || docs['introduction'];
}
